import { QueryKey } from "react-query";

export const createUsePaymentMethodsKey = (clinicId?: string): QueryKey => ["usePaymentMethods", clinicId];
